import React, { useState, useEffect } from 'react'
import callPostApi from 'requests/PostRequests';
import DashboardSummary from '../DashboardSummaryNew';
import * as Constants from '../../../requests/URLConstants';
import DashboardTable from '../DashboardTable';
import moment from 'moment';
import * as DashboardUtils from '../DashboardUtils.js';
import TableToolbarDownload from '../../../common/TableToolbarDownload';
import * as tableHeaders from './tableHeaders';
import axios from "axios";
import * as DashboardConstants from '.././DashboardConstants';
import * as workspaces from '../../../config/WorkspaceConstants'

const AutomationSchedulingEfficiency = (props) => {

    const [SummaryData, setSummaryData] = useState([]);
    const [SchedulerEfficiencyTableLoading, setSchedulerEfficiencyTableLoading] = useState(true);
    const [SummaryLoading, setSummaryLoading] = useState(true);
    const [SchedulerMissReportULLTableData, setSchedulerMissReportULLTableData] = useState([]);

    useEffect(() => {
        getSchedulerMissReportULL(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace, props.workspace);
        getSchedulerEfficiencyULL(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace, props.workspace);
    }, [props.preferencesChanged]);

    const getSchedulingefficiencySummaryData = (param) => {
        let summary = [{
            title: DashboardConstants.TotalRuns,
            value: param.totalruns
        },
        {
            title: DashboardConstants.SchedulerMisses,
            value: param.schedulermisses
        },
        {
            title: DashboardConstants.ReRuns,
            value: param.reruns
        },
        {
            title: DashboardConstants.SchedulerEfficiency,
            value: param.schedulerefficiency
        }]
        setSummaryData(summary);
    }

    const prepareSummaryData = (response1, response2) => {
        let summaryData = { totalruns: 0, schedulermisses: 0, reruns: 0, schedulerefficiency: 0 };
        let totalruns = 0, schedulermisses = 0, reruns = 0, schedulerefficiency = 0;
        totalruns = response2.aggregations["1"].value;
        schedulermisses = response1.aggregations.schd_misses.value;
        reruns = response1.aggregations.re_runs.value;
        schedulerefficiency = ((schedulermisses / totalruns) * 100).toFixed(2) + '%';

        if (response1) {
            summaryData = {
                schedulermisses: response1.aggregations.schd_misses.value,
                reruns: reruns,
                schedulerefficiency: schedulerefficiency
            };
        }
        summaryData.totalruns = totalruns;

        return { summaryData };
    };

    const getSchedulerEfficiencyULL = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setSummaryLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);

            axios.all([callPostApi(Constants.GETSCHEDULEREFFICIENCYULL, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(response1 => {
                    if (response1) {
                        return response1;
                    }
                }),
            callPostApi(Constants.GETTOTALRUNULL, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(response2 => {
                    if (response2) {
                        return response2;
                    }
                })]).then(axios.spread((response1, response2) => {
                    formattedData = prepareSummaryData(response1, response2);
                    getSchedulingefficiencySummaryData(formattedData.summaryData);
                    setSummaryLoading(false);
                })).catch((error) => {
                    setSummaryLoading(false);
                });
        }
    };

    const getSchedulerMissReportULL = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setSchedulerEfficiencyTableLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETSCHEDULERMISSREPORTULL, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(resp => {
                    formattedData = prepareSchedulerMissReportULL(resp);
                    setSchedulerMissReportULLTableData(formattedData);
                    setSchedulerEfficiencyTableLoading(false);
                }).catch((error) => {
                    setSchedulerEfficiencyTableLoading(false);
                });

        }
    };

    const prepareSchedulerMissReportULL = (response) => {
        let tableData = [];
        if (response) {
            let buckets = response.aggregations.automata_name.buckets;
            for (let j = 0; j < buckets.length; j++) {
                let botid = buckets[j].srvc_prc_name.buckets;
                for (let k = 0; k < botid.length; k++) {
                    let competency = botid[k].busn_competency_name.buckets;
                    for (let l = 0; l < competency.length; l++) {
                        let component = competency[l].busn_component_name.buckets;
                        for (let m = 0; m < component.length; m++) {
                            let deliverymodel = component[m].srvc_sub_prc_name.buckets;
                            for (let n = 0; n < deliverymodel.length; n++) {
                                let requestedby = deliverymodel[n].busn_srvc_task_name.buckets;
                                for (let o = 0; o < requestedby.length; o++) {
                                    let reasonforschedulermiss;
                                    let geo = requestedby[o].geo_name.buckets.length ? requestedby[o].geo_name.buckets : "-";
                                    if (requestedby[o].geo_name.buckets[0]) {
                                        reasonforschedulermiss = requestedby[o].geo_name.buckets[0].automata_info.buckets.length ? requestedby[o].geo_name.buckets[0].automata_info.buckets : ' ';
                                    } else { reasonforschedulermiss = "-" }

                                    for (let q = 0; q < geo.length; q++) {
                                        for (let p = 0; p < reasonforschedulermiss.length; p++) {

                                            tableData.push({
                                                id: ((j + 1).toString()) + Math.random(1),
                                                'processname': buckets[j].key,
                                                'botid': botid[k].key,
                                                'competency': competency[l].key,
                                                'component': component[m].key,
                                                'deliverymodel': deliverymodel[n].key,
                                                'requestedby': requestedby[o].key,
                                                'geo': geo[q].key ? geo[q].key : '-',
                                                'reruns': reasonforschedulermiss[p] && reasonforschedulermiss[p].rerun ? reasonforschedulermiss[p].rerun.value : 0,
                                                'schmisses': reasonforschedulermiss[p] && reasonforschedulermiss[p].doc_count ? reasonforschedulermiss[p].doc_count : 0,
                                                'reasonforschedulermiss': reasonforschedulermiss[p] && reasonforschedulermiss[p].key ? reasonforschedulermiss[p].key : "-"
                                            });
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        return tableData;
    };

    const getPayload = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        let calenderInterval = DashboardUtils.getCalenderInterval(timeFilterSelections);
        let timeZone = moment.tz.guess();
        let technology;
        let franchise;
        let client;
        let bodyJSON;

        if (workspace === workspaces.automation_ops) {
            technology = dashboardFilterSelectionsAutomation.technology;
            franchise = dashboardFilterSelectionsAutomation.franchise;
            client = dashboardFilterSelectionsAutomation.client;
            bodyJSON = {
                "filters": {
                    "time": {
                        "startDateTime": timeFilterSelections.startDateTime,
                        "endDateTime": timeFilterSelections.endDateTime
                    },
                    "franchises": franchise,
                    "clients": client,
                    "technologies": technology,
                    "deployment_models": dashboardFilterSelectionsAutomation.deployment_model,
                    "geos": dashboardFilterSelectionsAutomation.geo,
                    "business_competencies": dashboardFilterSelectionsAutomation.competency,
                    "automata_priority": dashboardFilterSelectionsAutomation.priority,
                    "status": dashboardFilterSelectionsAutomation.status,
                    "automata_state":dashboardFilterSelectionsAutomation.automata_state,
                    "automata_name": dashboardFilterSelectionsAutomation.automata_activity_name,
                    "bot_id": dashboardFilterSelectionsAutomation.bot_id,
                    "buisness_component": dashboardFilterSelectionsAutomation.buisness_component,
                    "process_name": dashboardFilterSelectionsAutomation.process_name
                },
                "interval": {
                    "calender_Interval": calenderInterval,
                    "time_zone": timeZone
                },
                "workspace": workspace
            };
        }
        return bodyJSON;
    };

    return (
        <div className="top-margin dashboard">
            <div className="dashboard-detail-container col-lg-12 no-gutters">
                <div className="dashboard-roleContainer col-lg-12">
                    <DashboardSummary loading={SummaryLoading} summary={SummaryData} title={DashboardConstants.SchedulingEfficiencySummary} />
                </div>
                <div className="dashboard-charts-container">
                    <div className="report-title">
                    </div>
                    <section className="border-bottom">
                        <div className="graph-title carbon-display-Regular-20">
                            <div>{DashboardConstants.SchedulerMissReport}</div>
                            <div className="download-button">
                                <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={SchedulerMissReportULLTableData} headers={tableHeaders.SchedulingEfficiencyTableHeaders} title={DashboardConstants.SchedulerMissReport} filename={DashboardConstants.SchedulerMissReport} label={DashboardConstants.Download} />
                            </div>
                        </div>
                        <div className="bold-border-table">
                            <DashboardTable loading={SchedulerEfficiencyTableLoading} rows={SchedulerMissReportULLTableData} headers={tableHeaders.SchedulingEfficiencyTableHeaders}
                                showPagination={true} isSortingAllowed={true} />
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default AutomationSchedulingEfficiency;
